import { Link } from "react-router-dom";

interface CharacterCardProps {
  id: string;
  name: string;
  actor: string;
  tagline: string;
  avatar: string;
  roleType: "lead" | "support";
}

export default function CharacterCard({
  id,
  name,
  actor,
  tagline,
  avatar,
  roleType,
}: CharacterCardProps) {
  return (
    <Link
      to={`/character/${id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-accent-300"
    >
      <div className="relative h-56 w-full overflow-hidden bg-secondary-200">
        <img
          src={avatar}
          alt={`《年轻的母亲2》角色 ${name}（由${actor}饰演）`}
          title={`${name} - 年轻的母亲2 角色介绍`}
          className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span
          className={`absolute left-3 top-3 rounded-full px-2.5 py-1 font-label text-xs font-semibold ${
            roleType === "lead"
              ? "bg-accent-500 text-primary-950"
              : "bg-secondary-500 text-background-50"
          }`}
        >
          {roleType === "lead" ? "主要角色" : "配角"}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-4">
        <div className="flex items-baseline gap-2">
          <h3 className="font-heading text-lg font-bold text-foreground-950 transition-colors group-hover:text-accent-600">
            {name}
          </h3>
          <span className="font-label text-xs text-foreground-500">饰 {actor}</span>
        </div>
        <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600 line-clamp-2">
          {tagline}
        </p>
        <span className="mt-3 flex items-center gap-1 font-label text-xs font-semibold text-primary-600">
          查看角色解析
          <span className="flex h-4 w-4 items-center justify-center">
            <i className="ri-arrow-right-line text-sm"></i>
          </span>
        </span>
      </div>
    </Link>
  );
}